import { G, Path, Svg } from "@react-pdf/renderer";
import React from "react";

interface Props {
    fill: string;
}

const No_Entry: React.FC<Props> = ({ fill }) => {
    return (
        <Svg fill={fill} id="Layer_1" viewBox="0 0 512 512" width="12pt" height="100%">
            <G>
                <Path d="M256,512c140.61,0,256-115.39,256-256S396.61,0,256,0S0,115.39,0,256S115.39,512,256,512z M76,211h360v90H76V211z" />
            </G>
        </Svg>
    );
};

export default No_Entry;
